module.exports = __webpack_public_path__ + "img/logo-light-icon.90af9028.png";